import { render, staticRenderFns } from "./WebComponentThumb.vue?vue&type=template&id=30630b7a&scoped=true&"
import script from "./WebComponentThumb.vue?vue&type=script&lang=js&"
export * from "./WebComponentThumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30630b7a",
  null
  
)

export default component.exports